import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('daywise_shrimp_analysis')
export class DaywiseShrimpAnalysisEntity{
    @PrimaryGeneratedColumn('increment', {name: 'id'})
    id: number;

    @Column('varchar',{
        name: 'variant',
        length : 50,
        nullable:false
    })
    variant : string

    @Column('int',{
        name:'variant_id',
        nullable:false
    })
    variantId:number

    @Column('varchar',{
        name: 'pack_style',
        length : 30,
        nullable:false
    })
    packStyle : string

    @Column('int',{
        name:'pack_style_id',
        nullable:false
    })
    packStyleId:number

    @Column('varchar',{
        name: 'grade',
        length : 30,
        nullable:false
    })
    grade : string

    @Column('int',{
        name:'grade_id',
        nullable:false
    })
    gradeId:number

    @Column('varchar',{
        name: 'va1',
        length : 10,
        nullable:false
    })
    va1 : string

    @Column('varchar',{
        name: 'va2',
        length : 10,
        nullable:false
    })
    va2 : string

    @Column('varchar',{
        name: 'va3',
        length : 10,
        nullable:false
    })
    va3 : string

    @Column('varchar',{
        name: 'va4',
        length : 10,
        nullable:false
    })
    va4 : string

    @Column('varchar',{
        name: 'va5',
        length : 10,
        nullable:false
    })
    va5 : string

    @Column('varchar',{
        name: 'product_category',
        length : 50,
        nullable:false
    })
    productCategory : string
    
    @Column('int',{
        name:'plant_id',
        nullable:false
    })
    plantId:number

    @Column('datetime',{
        name:'date',
        nullable:false
    })
    date: Date

    @Column('int',{
        name:'fresh_prod_cases'
    })
    freshProdCases:number

    @Column('int',{
        name:'fresh_prod_loose_pouches'
    })
    freshProdLoosePouches:number

    @Column('decimal',{
        name:'fresh_prod_qty_kg',
        precision:10,scale:3,
        unsigned:true
    })
    freshProdQtyKg: number

    @Column('int',{
        name:'reproduction_cases'
    })
    reproductionCases:number

    @Column('int',{
        name:'reproduction_loose_pouches'
    })
    reproductionLoosePouches:number

    @Column('decimal',{
        name:'reproduction_qty_kg',
        precision:10,scale:3,
        unsigned:true
    })
    reproductionQtyKg: number

    @Column('decimal',{
        name:'total_prod_qty_kg',
        precision:10,scale:3,
        unsigned:true
    })
    totalProdQtyKg: number

    @Column('int',{
        name:'shipment_cases'
    })
    shipmentCases:number

    @Column('int',{
        name:'shipment_loose_pouches'
    })
    shipmentLoosePouches:number

    @Column('decimal',{
        name:'shipment_qty_kg',
        precision:10,scale:3,
        unsigned:true
    })
    shipmentQtyKg: number

    @Column('int',{
        name:'reprocess_cases'
    })
    reprocessCases:number

    @Column('int',{
        name:'reprocess_loose_pouches'
    })
    reprocessLoosePouches:number

    @Column('decimal',{
        name:'reprocess_qty_kg',
        precision:10,scale:3,
        unsigned:true
    })
    reprocessQtyKg: number

    @Column('int',{
        name:'lab_sample_cases'
    })
    labSampleCases:number

    @Column('int',{
        name:'lab_sample_loose_pouches'
    })
    labSampleLoosePouches:number

    @Column('decimal',{
        name:'lab_sample_qty_kg',
        precision:10,scale:3,
        unsigned:true
    })
    labSampleQtyKg: number

    @Column('int',{
        name:'domestic_sale_cases'
    })
    domesticSaleCases:number

    @Column('int',{
        name:'domestic_sale_loose_pouches'
    })
    domesticSaleLoosePouches:number

    @Column('decimal',{
        name:'domestic_sale_qty_kg',
        precision:10,scale:3,
        unsigned:true
    })
    domesticSaleQtyKg: number

    @Column('int',{
        name:'food_type_id',
        nullable:false
    })
    foodTypeId :number

    @Column('int',{
        name:'product_id',
        nullable:false
    })
    productId :number   

    @Column('varchar',{
        name:'soak_style',
        nullable:false
    })
    soakStyle :number

    

}